module.exports = __webpack_public_path__ + "img/logo-as-hero-bg-shape.265b119.svg";